import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const PaymentsIcon = ({ color = Colors.interaction }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <mask
      id="mask0_905_1221"
      style={{ maskType: 'alpha' }}
      width="24"
      height="24"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H24V24H0z" />
    </mask>
    <g mask="url(#mask0_905_1221)">
      <path
        fill={color}
        d="M5.308 20.5c-.499 0-.925-.177-1.278-.53a1.741 1.741 0 01-.53-1.278V5.308c0-.499.177-.925.53-1.278.353-.353.779-.53 1.278-.53h13.384c.499 0 .925.177 1.278.53.353.353.53.779.53 1.278v2.72H19v-2.72a.3.3 0 00-.087-.221.3.3 0 00-.22-.087H5.307a.3.3 0 00-.221.087.3.3 0 00-.087.22v13.385a.3.3 0 00.087.221.3.3 0 00.22.087h13.385a.3.3 0 00.221-.087.3.3 0 00.087-.22V15.97h1.5v2.721c0 .499-.177.925-.53 1.278-.353.353-.779.53-1.278.53H5.308zm8-4c-.499 0-.925-.177-1.278-.53a1.741 1.741 0 01-.53-1.278V9.308c0-.499.177-.925.53-1.278.353-.353.779-.53 1.278-.53h6.384c.499 0 .925.177 1.278.53.353.353.53.779.53 1.278v5.384c0 .499-.177.925-.53 1.278-.353.353-.779.53-1.278.53h-6.384zm6.384-1.5a.3.3 0 00.221-.087.3.3 0 00.087-.22V9.307a.3.3 0 00-.087-.221.3.3 0 00-.22-.087h-6.385a.3.3 0 00-.222.087.3.3 0 00-.086.22v5.385a.3.3 0 00.086.221.3.3 0 00.222.087h6.384zM16 13.5c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0016 10.5c-.417 0-.77.146-1.063.438A1.446 1.446 0 0014.5 12c0 .417.146.77.438 1.063.291.291.645.437 1.062.437z"
      />
    </g>
  </svg>
);

PaymentsIcon.propTypes = {
  color: PropTypes.string
};

export default PaymentsIcon;
